<div class="main-layout" [class.main-layout--guest-legal]="guestLegalDocumentLayout()">
  @if (guestLegalDocumentLayout()) {
    <app-landing-navbar />
    <main class="content content--guest-legal">
      <router-outlet />
    </main>
  } @else {
    <app-sidebar (logoutRequested)="onLogoutRequested()" />
    <div class="main-area">
      @if (showNavbar()) {
        <app-navbar [pageTitle]="pageTitle()" />
      }
      <main class="content">
        <router-outlet />
      </main>
    </div>
  }

  <app-logout-modal
    [isOpen]="logoutModalOpen()"
    (closed)="closeLogoutModal()"
    (confirm)="onLogoutConfirm()"
  />

  <app-login-modal
    [isOpen]="authOverlay.loginOpen()"
    (closed)="authOverlay.closeLogin()"
    (loginSuccess)="onOverlayLoginSuccess()"
    (registerClick)="authOverlay.switchLoginToSignup()"
    (forgotPasswordClick)="onOverlayForgotPassword()"
  />
  <app-forgot-password-modal
    [isOpen]="authOverlay.forgotPasswordOpen()"
    (closed)="authOverlay.closeForgotPassword()"
  />
  <app-sign-up-modal
    [isOpen]="authOverlay.signupOpen()"
    (closed)="authOverlay.closeSignup()"
    (loginClick)="authOverlay.switchSignupToLogin()"
    (registerSuccess)="onOverlayRegisterSuccess()"
  />
</div>
